import type { Series } from '../types';

export function getSeriesTotalSeasons(series: Series): number {
  return series.seasons.length;
}
